export const subjectOrder = [
    // 國文
    {_id: 'PPC', name: '國小國語'},
    {_id: 'PC', name: '國中國文'},
    {_id: 'HPC', name: '高中國文'},

    // 英語
    {_id: 'PEN', name: '國小英語'},
    {_id: 'EN', name: '國中英語'},
    {_id: 'HEN', name: '高中英文'},

    // 數學
    {_id: 'PMA', name: '國小數學'},
    {_id: 'MA', name: '國中數學'},
    {_id: 'HMA', name: '高中數學'},

    // 自然
    {_id: 'PNA', name: '國小自然'},
    {_id: 'NA', name: '國中自然'},
    {_id: 'HNA', name: '高中自然'},

    // 高中自子科
    {_id: 'HBI', name: '高中生物'},
    {_id: 'PH', name: '高中物理'},
    {_id: 'CE', name: '高中化學'},
    {_id: 'HEA', name: '高中地球科學'},

    // 社會
    {_id: 'PSO', name: '國小社會'},
    {_id: 'SO', name: '國中社會'},
    {_id: 'HSO', name: '高中社會'},

    // 高中社會子科
    {_id: 'HHI', name: '高中歷史'},
    {_id: 'HGE', name: '高中地理'},
    {_id: 'HCS', name: '高中公民'},
];

export const subjectIconMap = new Map([
    // 國小
    ['PPC', 'chinese'],
    ['PEN', 'english'],
    ['PMA', 'math'],
    ['PNA', 'nature-2'],
    ['PSO', 'society-2'],
    // 國中
    ['PC', 'chinese'],
    ['EN', 'english'],
    ['MA', 'math'],
    ['NA', 'nature-3'],
    ['SO', 'society-2'],
    // 高中
    ['HPC', 'chinese'],
    ['HEN', 'english'],
    ['HMA', 'math'],
    ['HNA', 'nature-3'],
    ['HBI', 'nature'],
    ['PH', 'physics'],
    ['CE', 'chemical'],
    ['HEA', 'geology'],
    ['HSO', 'society-2'],
    ['HHI', 'history'],
    ['HGE', 'geography'],
    ['HCS', 'society'],
]);

export const featureIconMap = new Map([
    ['home', 'home'],
    ['SelfAssessment', 'assessment'],
    ['MasterCinema', 'play'],
    ['WrongQuestionReview', 'hashtag'],
    ['ExamRecord', 'records'],
    ['signout', 'signout']
]);

export const taskIconMap = new Map([
    ['Web', 'link'],
    ['ExtraVideo', 'play'],
    ['Video', 'play'],
    ['CorrectionExam', 'hashtag'],
    ['KnowledgeExam', 'hashtag'],
    ['Exam', 'exam']
]);

export const styleClassMap = new Map([
    ['V2-PRO', 'pro'],
    ['V2-TUTOR', 'tutor'],
    ['V2-LITE', 'lite'],
])

export const checkGrade = (subjectId) => {
    if (!subjectId) return null;

    const primarySubjects = ['PPC', 'PEN', 'PMA', 'PNA', 'PSO'];
    const juniorSubjects = ['PC', 'EN', 'MA', 'NA', 'SO'];

    if (primarySubjects.includes(subjectId)) {
        return 'primary';
    } else if (juniorSubjects.includes(subjectId)) {
        return 'junior';
    }
    return 'senior';
}
